<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Epigraph"> </h1>
<blockquote>
<p class="sectiontop">The figure of my sister in her chair by the kitchen fire, haunted me night and day. That the place could possibly be, without her, was something my mind seemed unable to compass; and whereas she had seldom or never been in my thoughts of late, I had now the strangest ideas that she was coming towards me in the street, or that she would presently knock at the door. In my own rooms, too, with which she had never been at all associated, there was at once the blankness of death and a perpetual suggestion of the sound of her voice or the turn of her face or figure, as if she were still alive and had been often there.</p>
<p style="text-align:right">—Charles Dickens, <i>Great Expectations</i></p>
</blockquote>
<blockquote>
<p class="first">So, pursuing the one course of thought, he had the one relentless monster still before him. All things looked black, and cold, and deadly upon him, and he on them. He found a likeness to his misfortune everywhere. There was a remorseless triumph going on about him, and it galled and stung him in his pride and jealousy, whatever form it took: though most of all when it divided with him the love and memory of his lost boy.</p>
<p style="text-align:right;">—Charles Dickens, <i>Dombey and Son</i></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM6_Epigraph.vue?78794122